export default "__VITE_ASSET__252cedd8__"